exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SaveResult .error{margin-bottom:0}.SaveResult-modal .LoginForm{margin-bottom:calc(-10px - 6px - 24px)}.SaveResult-modal .buttons{display:flex;justify-content:space-between}.SaveResult-modal .buttons button{margin:5px;padding:3px 6px}@media all and (max-width: 799px){.SaveResult-modal .SaveResult-modal .modal{position:relative}.SaveResult-modal .SaveResult-modal .modal-body{overflow-y:scroll}}\n", ""]);

// exports
